<template>
  <div class="form add-class">
    <div class="form__header">
      <h3>Редактирование класса</h3>
    </div>

    <div class="form__body">
      <Input 
        class="form__field" 
        v-model="formData.title" 
        label="Название" 
        type="text" 
        id="class-title" 
        :required="true" 
      />

      <p class="form__field">
        <span>День занятий:</span>
        <select 
          name="day" 
          v-model="formData.day"
          class="required"
          :class="{
            valid: formData.day,
            invalid: !formData.day,
          }"
        >
          <option value="" selected disabled>Выберите день занятий</option>
          <option v-for="val in days" :value="val" :key="val.id">{{ val }}</option>
        </select>
      </p>

      <p class="form__field">
        <span>Время:</span>
        <vue-timepicker 
          class="required"
          :class="{
            valid: formData.time,
            invalid: !formData.time,
          }"
          input-class="time-input" 
          input-width="100%" 
          v-model="formData.time
        "></vue-timepicker>
      </p>

      <p class="form__field">
        <span>Описание:</span>
        <textarea 
          v-model="formData.desc"
          rows="4"
        ></textarea>
      </p>
    </div>

    <div class="form__footer">
      <SubmitButton :isValid="isValid" @submit="onUpdateClass" text="Сохранить" />
    </div>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import SubmitButton from '../../../other/SubmitButton'
import Input from '../../../other/Input'

export default {
  name: "edit-class",
  components: { VueTimepicker, SubmitButton, Input },
  data() {
    return {
      formData: {},
      days: [
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота',
        'Воскресенье',
      ],
      requiredKeys: ['title', 'day', 'time']
    }
  },
  props: ['data'],
  inject: ['http'],
  computed: {
    isValid() {
      let valid = true

      this.requiredKeys.forEach(key => {
        if (!this.formData[key]) {
          valid = false
        }
      })
      return valid
    }
  },
  methods: {
    stringDesc(s) {
      return s.replace(/<\/?[a-zA-Z]+>/gi, '');
    },
    onUpdateClass(){
      this.$emit('update-class', this.formData)
      this.$emit('close-popup');
    }
  },
  mounted() {
    this.formData = Object.assign({}, this.data)
    this.data.desc = this.stringDesc(this.data.desc);
    if (!this.data.time) {
      this.data.time = ''
    }
  }
}
</script>

<style lang="scss">
.editclass {
  position: relative;
}
.vue__time-picker {
  width: 50%;
}

.time-picker {
  box-sizing: border-box;
  width: 100%;
}

.vue__time-picker input.display-time {
  height: 40px;
}
</style>